import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { PromotionLeaderboardRoutingModule } from './promotion-leaderboard-routing.module';
import { PromotionLeaderboardComponent } from './promotion-leaderboard.component';
import { CommonService } from '../core/service/common.service';
import { PromotionLeaderboardService } from '../core/service/promotion-leaderboard.service';
import { PromotionLeaderboardGroupComponent } from './group/promotion-leaderboard-group.component';
import { PromotionLeaderboardViewComponent } from './view/promotion-leaderboard-view.component';
import { PromotionLeaderboardMyRankComponent } from './my-rank/promotion-leaderboard-my-rank.component';
import { PromotionLeaderboardListTableComponent } from './list-table/promotion-leaderboard-list-table.component';
import { WsopNationalityRankingTableComponent } from './wsop-nationality-ranking-table/wsop-nationality-ranking-table.component';


@NgModule({
    declarations: [
        PromotionLeaderboardComponent,
        PromotionLeaderboardGroupComponent,
        PromotionLeaderboardMyRankComponent,
        PromotionLeaderboardListTableComponent,
        PromotionLeaderboardViewComponent,
        WsopNationalityRankingTableComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        PromotionLeaderboardRoutingModule,
        FormsModule
    ],
    providers: [
        CommonService,
        PromotionLeaderboardService
    ]
})
export class PromotionLeaderboardModule {
    constructor() {
    }
}
